/* BW Favorites · página /pages/favoritos. Pinta las tarjetas con la MISMA tarjeta del tema (snippets/product-card)
   pidiendo cada producto al servidor con la plantilla alternativa product.fav-card (/products/{handle}?view=fav-card).
   Así las tarjetas llevan precio con/sin IVA, badges, compra rápida e IVA toggle sin duplicar código. */
(function () {
  'use strict';

  var grid, empty, count;

  function fetchCard(handle) {
    return fetch('/products/' + encodeURIComponent(handle) + '?view=fav-card', { headers: { Accept: 'text/html' } })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .catch(function () { return ''; });
  }

  function showEmpty(isEmpty) {
    if (grid) grid.hidden = isEmpty;
    if (empty) empty.hidden = !isEmpty;
    if (count) count.hidden = isEmpty;
  }

  function render() {
    if (!grid) return;
    var list = (window.BWWishlist && window.BWWishlist.read) ? window.BWWishlist.read().slice().reverse() : [];
    if (!list.length) { grid.innerHTML = ''; showEmpty(true); updateAddAll(); return; }
    showEmpty(false);
    grid.setAttribute('aria-busy', 'true');
    Promise.all(list.map(function (it) { return fetchCard(it.h); })).then(function (cards) {
      grid.innerHTML = cards.map(function (html) { return html.trim() ? '<li>' + html + '</li>' : ''; }).join('');
      grid.removeAttribute('aria-busy');
      if (count) count.textContent = String(grid.querySelectorAll('li').length);
      if (window.BWWishlist && window.BWWishlist.apply) window.BWWishlist.apply();
      if (!grid.querySelector('li')) showEmpty(true);
      updateAddAll();
    });
  }

  /* Al quitar un favorito desde la propia página, fuera la tarjeta sin volver a pedir todas */
  document.addEventListener('bw:wishlist:change', function () {
    if (!grid || grid.hidden) { render(); return; }
    var list = (window.BWWishlist && window.BWWishlist.read) ? window.BWWishlist.read() : [];
    var keep = {};
    list.forEach(function (it) { keep[it.h] = true; });
    grid.querySelectorAll('li').forEach(function (li) {
      var btn = li.querySelector('.bw-fav-btn[data-product-handle]');
      if (btn && !keep[btn.dataset.productHandle]) li.remove();
    });
    var n = grid.querySelectorAll('li').length;
    if (count) count.textContent = String(n);
    if (!n) showEmpty(true);
    updateAddAll();
  });

  /* «Añadir todos al carrito» (oct-2026): el cliente que repite pedido tiene sus productos en favoritos.
     Se añaden los que tienen compra directa en la tarjeta (sin opciones y con stock); los que piden elegir
     color o están agotados se cuentan y se avisa. */
  function buyable() {
    var ids = [], skipped = 0;
    grid.querySelectorAll('li').forEach(function (li) {
      var input = li.querySelector('form.js-product-form input[name="id"]');
      var btn = li.querySelector('form.js-product-form [name="add"]');
      if (input && input.value && !(btn && btn.disabled)) ids.push(Number(input.value)); else skipped++;
    });
    return { ids: ids, skipped: skipped };
  }

  function updateAddAll() {
    var btn = document.querySelector('[data-bw-fav-addall]');
    if (!btn || !grid) return;
    btn.hidden = grid.hidden || buyable().ids.length === 0;
  }

  function addAll(btn) {
    var msg = document.querySelector('[data-bw-fav-addall-msg]');
    var b = buyable();
    if (!b.ids.length) return;
    btn.disabled = true;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: b.ids.map(function (id) { return { id: id, quantity: 1 }; }) })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || d.message || 'No se han podido añadir.'); });
      /* Si se ha saltado alguno, se deja leer el aviso antes de ir al carrito */
      setTimeout(function () { window.location.href = root + 'cart'; }, b.skipped ? 2500 : 0);
    }).catch(function (e) {
      btn.disabled = false;
      if (msg) { msg.textContent = e.message; msg.hidden = false; }
    });
    if (msg && b.skipped) {
      msg.textContent = b.skipped + (b.skipped === 1 ? ' producto necesita' : ' productos necesitan') + ' elegir color o están agotados: añádelos desde su ficha.';
      msg.hidden = false;
    }
  }

  function init() {
    grid = document.querySelector('[data-bw-fav-grid]');
    empty = document.querySelector('[data-bw-fav-empty]');
    count = document.querySelector('[data-bw-fav-count]');
    if (!grid) return;
    var btn = document.querySelector('[data-bw-fav-addall]');
    if (btn && !btn.dataset.bound) {
      btn.dataset.bound = '1';
      btn.addEventListener('click', function () { addAll(btn); });
    }
    render();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
